const BASE = ['goaml'] as const;

export const GOAML_QUERY_KEYS = {
  config: () => [...BASE, 'config'] as const,
  filing: (id: number) => [...BASE, 'filing', id] as const,
  referenceTables: () => [...BASE, 'reference-tables'] as const,
};
